import { create } from 'zustand';
import type { TimelineStore } from './types';
import {
  buildNodeMap,
  clearActivePath,
  markActivePath,
  populateChildren,
} from './store-utils';

const initialState = {
  conversationId: null as string | null,
  conversationName: null as string | null,
  activePlatform: null as TimelineStore['activePlatform'],
  nodes: new Map(),
  rootNodeId: null as string | null,
  currentLeafId: null as string | null,
  isLoading: false,
  error: null as string | null,
};

export const useTimelineStore = create<TimelineStore>((set, get) => ({
  ...initialState,

  clearConversation: () => {
    set({
      conversationId: null,
      conversationName: null,
      nodes: new Map(),
      rootNodeId: null,
      currentLeafId: null,
      isLoading: false,
      error: null,
    });
  },

  setConversationData: (conversation) => {
    const nodeMap = buildNodeMap(conversation.messages);
    const rootNodeId = populateChildren(nodeMap);

    if (conversation.currentLeafId) {
      markActivePath(nodeMap, conversation.currentLeafId);
    }

    set({
      conversationId: conversation.id,
      conversationName: conversation.name,
      nodes: nodeMap,
      rootNodeId,
      currentLeafId: conversation.currentLeafId,
      isLoading: false,
      error: null,
    });
  },

  updateCurrentLeaf: (newLeafId) => {
    const nodes = get().nodes;
    if (nodes.size === 0 || !nodes.has(newLeafId)) {
      return;
    }

    clearActivePath(nodes);
    markActivePath(nodes, newLeafId);

    set({
      currentLeafId: newLeafId,
      nodes: new Map(nodes),
    });
  },

  setActivePlatform: (platform) => {
    set({ activePlatform: platform });
  },

  setLoading: (isLoading) => {
    set({ isLoading });
  },

  setError: (error) => {
    set({ error });
  },
}));
